module.exports = __webpack_public_path__ + "img/Conoce-Aicad.feabf271.png";